import React, { useEffect, useState } from 'react';
import { HostedForm } from 'react-acceptjs';
import { FaLinkSlash } from "react-icons/fa6";
import { FiLoader, FiDownload } from "react-icons/fi";
import { MdOutlineReceipt } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import full from './full_logo.png';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

function AuthorizeNet() {
  const { id } = useParams();
  const [amount, setAmount] = useState();
  const [product, setProduct] = useState('');
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(true);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [loginId, setLoginId] = useState('');
  const [clientKey, setClientKey] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [successUrl, setSuccessUrl] = useState('');
  const [products, setProducts] = useState([]);
  const [userName, setUserName] = useState('');
  const [productEnabled, setProductEnabled] = useState(false);
  const [taxEnabled, setTaxEnabled] = useState(false);
  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [AddProductPrice, setAddProductPrice] = useState(0);
  const [AddProductDiscount, setAddProductDiscount] = useState(0);
  const [AddProductTax, setAddProductTax] = useState(0);
  const [address, setAddress] = useState([]);
  const [Surcharge, setSurcharge] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const [isExpired, setisExpired] = useState(false);
  const [authorizeData, setAuthorizeData] = useState(null);

  useEffect(() => {
    handleGetPaymentAuthorize();
  }, []);

  const handleGetPaymentAuthorize = async () => {
    setLoading1(true);
    const response = await axios.get(`${baseURL}/payment/authorize/get-payment-data/${id}`, config);
    if (response.data.status === 'success') {
      const data = response.data.data.entity;
      setAuthorizeData(data);
      setAmount(data.amount);
      setTotalAmount(data?.body?.amount);
      setProduct(data.product);
      setCompanyLogo(data?.company_logo);
      setCompanyName(data.company_name);
      setLoginId(data.api_login_id);
      setClientKey(data.public_client_key);
      setCompanyId(data.company_id);
      setSuccessUrl(data?.success_url);
      setProducts(data?.body?.products || []);
      setUserName(data?.name);
      setDiscountEnabled(data?.settings?.is_discount_enabled);
      setTaxEnabled(data?.settings?.is_tax_enabled);
      setProductEnabled(data?.settings?.bill_to_name);
      setAddress(data?.company_address);
      setSurcharge(data?.surcharge);
      setIsPaid(data?.payment_status === 'paid' ? true : false);
      setisExpired(data?.is_expire);
    }
    setLoading1(false);
  };

  useEffect(() => {
    let totalPrice = 0;
    let totalDiscount = 0;
    let Totaltax = 0;
    if (productEnabled === true && products != undefined) {
      for (const product1 of products) {
        const productTotalPrice = product1.price * product1.quantity;
        totalPrice += productTotalPrice;
        const discountValue = Number(product1.discount) || 0;
        const isUsdDiscount = String(product1.discountType || '').toUpperCase() === 'USD';
        const productTotalDiscount = isUsdDiscount
          ? discountValue
          : (productTotalPrice * discountValue) / 100;
        totalDiscount += productTotalDiscount;
        const productTotalTAX = ((productTotalPrice - productTotalDiscount) * product1.tax) / 100;
        Totaltax += productTotalTAX;
      }
      setAddProductPrice(totalPrice.toFixed(2));
      setAddProductDiscount(totalDiscount.toFixed(2));
      setAddProductTax(Totaltax.toFixed(2));
      setTotalAmount((totalPrice - totalDiscount + Totaltax).toFixed(2));
    }
  }, [loading1, amount, products, productEnabled]);

  const amountAfterDiscount = productEnabled
    ? Number(TotalAmount) || 0
    : Number(amount) || 0;
  const convenienceFee = Surcharge === true ? amountAfterDiscount * 0.03 : 0;
  const payableTotal = (amountAfterDiscount + convenienceFee).toFixed(2);

  const authData = {
    apiLoginID: loginId,
    clientKey: clientKey,
  };

  const handleSubmit = async (response) => {
    setLoading(true);
    const formData = {
      dataValue: response?.opaqueData?.dataValue,
    }
    const res = await axios.post(`${baseURL}/payment/authorize/process-transaction/${companyId}/${id}`, formData, config);
    if (res.data.status === 'success') {
      handleGetPaymentAuthorize();
      setLoading(false);
    } else {
      window.alert(res.message);
      setLoading(false);
    }
  };

  const handleInvoice = async () => {
    const invoiceData = authorizeData;
    
    // Create invoice HTML with modern design
    const invoiceHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoice - ${invoiceData?.id || 'N/A'}</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          body { font-family: 'Inter', sans-serif; }
          .invoice-header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
          .status-paid { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }
          @media print {
            body { print-color-adjust: exact; }
            .no-print { display: none !important; }
          }
        </style>
      </head>
      <body class="bg-gray-50 p-8">
        <div class="max-w-4xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden">
          <!-- Header -->
          <div class="invoice-header text-white px-8 py-6">
            <div class="flex justify-between items-start">
              <div class="flex items-center space-x-4">
                ${companyLogo ? `<img src="${companyLogo}" alt="Company Logo" class="h-16 w-16 rounded-lg bg-white p-2">` : ''}
                <div>
                  <h1 class="text-2xl font-bold">${companyName}</h1>
                  <p class="text-blue-100">${address?.street_address || ''} ${address?.apartment_or_suite || ''}</p>
                  <p class="text-blue-100">${address?.city || ''}, ${address?.state_or_province || ''} ${address?.zip || ''}</p>
                </div>
              </div>
              <div class="text-right">
                <h2 class="text-3xl font-bold mb-2">INVOICE</h2>
                <div class="status-paid text-white px-4 py-2 rounded-lg inline-block">
                  <span class="font-semibold">PAID</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Invoice Details -->
          <div class="px-8 py-6">
            <div class="grid grid-cols-2 gap-8 mb-8">
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-3">Bill To:</h3>
                <div class="bg-gray-50 p-4 rounded-lg">
                  <p class="font-medium text-gray-800">${userName}</p>
                  <p class="text-gray-600">${invoiceData?.email || 'Email not provided'}</p>
                  <p class="text-gray-600">${invoiceData?.phone || ''}</p>
                </div>
              </div>
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-3">Invoice Details:</h3>
                <div class="bg-gray-50 p-4 rounded-lg space-y-2">
                  <div class="flex justify-between">
                    <span class="text-gray-600">Invoice #:</span>
                    <span class="font-medium">${invoiceData?.id || 'N/A'}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Date:</span>
                    <span class="font-medium">${new Date().toLocaleDateString()}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Payment Method:</span>
                    <span class="font-medium">Credit Card</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Items -->
            <div class="mb-8">
              <h3 class="text-lg font-semibold text-gray-800 mb-4">Items:</h3>
              <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <table class="w-full">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${product}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$${(Surcharge ? (amount / 1.03) : amount)?.toFixed(2)}</td>
                    </tr>
                    ${Surcharge ? `
                    <tr>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Convenience Fee (3%)</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$${((amount / 1.03) * 0.03)?.toFixed(2)}</td>
                    </tr>
                    ` : ''}
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Total -->
            <div class="flex justify-end">
              <div class="w-80">
                <div class="bg-gray-50 p-6 rounded-lg">
                  <div class="flex justify-between items-center py-2 border-b border-gray-200">
                    <span class="text-lg font-semibold text-gray-800">Total Amount:</span>
                    <span class="text-2xl font-bold text-gray-800">$${amount?.toFixed(2)}</span>
                  </div>
                  <div class="flex justify-between items-center py-2 mt-2">
                    <span class="text-lg font-semibold text-green-600">Amount Paid:</span>
                    <span class="text-2xl font-bold text-green-600">$${amount?.toFixed(2)}</span>
                  </div>
                  <div class="flex justify-between items-center py-2 mt-2 pt-4 border-t border-gray-200">
                    <span class="text-lg font-semibold text-gray-800">Balance Due:</span>
                    <span class="text-2xl font-bold text-gray-800">$0.00</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="mt-8 pt-6 border-t border-gray-200 text-center text-gray-500">
              <p>Thank you for your business!</p>
              <div class="flex justify-center items-center mt-4">
                <span class="text-sm">Powered by</span>
                <img src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png" class="h-4 ml-2" alt="SalesCaptain">
                <span class="ml-1 font-semibold text-sm">SalesCaptain</span>
              </div>
            </div>
          </div>
        </div>
      </body>
      </html>
    `;

    // Create hidden iframe for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.left = '-9999px';
    iframe.style.top = '-9999px';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    
    // Append iframe to body
    document.body.appendChild(iframe);
    
    // Write content to iframe
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(invoiceHTML);
    iframeDoc.close();
    
    // Wait for content to load then print
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.print();
        // Clean up - remove iframe after printing
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 500);
    };
  };

  if (loading1) {
    return (
      <div className="w-full h-[100vh] items-center justify-between flex flex-col">
        <FiLoader size={50} className="animate-spin mt-[47vh]" />
        <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
          <span className="text-[#535355]"> Powered by</span>
          <div
            className='flex items-center ml-1 cursor-pointer'
            onClick={() => window.open('https://www.salescaptain.com')}
          >
            <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className=" h-[18px]" alt="" />
            <span
              className="font-semibold ml-1"
            >
              {localStorage.getItem('h_name') ?? 'SalesCaptain'}
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="w-screen h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 p-8">
          <div className="flex flex-col items-center space-y-4">
            <FiLoader size={50} className="animate-spin text-blue-500" />
            <span className="text-lg font-medium text-gray-700">Processing Payment...</span>
            <p className="text-sm text-gray-500">Please wait while we process your transaction</p>
          </div>
        </div>
      </div>
    );
  }

  if (isExpired === true) {
    return (
      <div className="w-full h-full items-center justify-center flex flex-col bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 p-8">
          <div className="flex flex-col items-center space-y-4">
            <FaLinkSlash className="text-[80px] text-gray-400" />
            <span className="text-2xl font-semibold text-gray-700">Link Expired</span>
            <p className="text-gray-500 text-center">This payment link is no longer valid</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col items-center justify-center p-4" id="payment-receipt">
      {/* Modern Header */}
      <div className="w-full max-w-md mb-6">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {companyLogo && (
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 p-0.5">
                  <div className="w-full h-full rounded-xl bg-white p-2">
                    <img className="w-full h-full object-contain" src={companyLogo} alt="Company Logo" />
                  </div>
                </div>
              )}
              <div className="flex-1">
                <h1 className="text-xl font-bold text-gray-800 leading-tight">{companyName}</h1>
                <p className="text-sm text-gray-500 leading-tight">
                  {address?.street_address} {address?.apartment_or_suite}
                </p>
                <p className="text-sm text-gray-500">
                  {address?.city}, {address?.state_or_province} {address?.zip}
                </p>
              </div>
            </div>
            
            {/* Download Invoice Button - Only show when paid */}
            {isPaid && (
              <div className="ml-4">
                <button 
                  onClick={handleInvoice} 
                  className="group flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-4 py-2 rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105"
                >
                  <FiDownload className="w-4 h-4 group-hover:animate-bounce" />
                  <span className="text-sm font-medium">Invoice</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modern Payment Card */}
      <div className="w-full max-w-md">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 overflow-hidden">
          {/* Card Header */}
          <div className="bg-slate-50 p-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-semibold text-slate-800">Payment Details</h2>
              </div>
              {isPaid && (
                <div className="flex items-center space-x-2 bg-emerald-50 rounded-full px-3 py-1">
                  <FaCheckCircle className="w-4 h-4 text-emerald-500" />
                  <span className="text-sm font-medium text-emerald-500">Paid</span>
                </div>
              )}
            </div>
          </div>

          {/* Card Content */}
          <div className="p-6">
            {/* Bill To */}
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-600 font-medium">Bill to:</span>
              <span className="text-gray-800 font-semibold">{userName}</span>
            </div>

            {/* Product Details */}
            {productEnabled === true && products?.length > 1 && (
              <div className="border-b border-gray-100 pb-4">
                <h3 className="text-gray-600 font-medium mb-3">Products:</h3>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {products?.map((field, index) => (
                    <div key={index} className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">
                        {field.quantity}× {field.product}
                      </span>
                      <span className="font-medium text-gray-800">
                        ${(field.price * field.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Single Product or Service */}
            {(productEnabled === true && products?.length === 1) || !productEnabled && (
              <div className="text-center py-4 border-b border-gray-100">
                <div className="inline-flex items-center space-x-2 bg-gray-50 rounded-full px-4 py-2">
                  <MdOutlineReceipt className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700 font-medium">
                    {productEnabled ? products[0]?.product : product}
                  </span>
                </div>
              </div>
            )}

            {/* Amount Breakdown */}
            <div className="space-y-3">
              {/* Subtotal */}
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span className="font-medium text-gray-800">
                  ${productEnabled ? AddProductPrice : (Surcharge === true) ? (amount / 1.03)?.toFixed(2) : amount?.toFixed(2)}
                </span>
              </div>

              {/* Discount */}
              {discountEnabled && productEnabled && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Discount</span>
                  <span className="font-medium text-red-500">-${AddProductDiscount}</span>
                </div>
              )}

              {/* Tax */}
              {taxEnabled && productEnabled && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Tax</span>
                  <span className="font-medium text-gray-800">${AddProductTax}</span>
                </div>
              )}

              {/* Convenience Fee */}
              {Surcharge === true && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600 text-sm">Convenience fee (3%)</span>
                  <span className="font-medium text-gray-800">
                    ${convenienceFee.toFixed(2)}
                  </span>
                </div>
              )}

              {/* Total Amount */}
              {isPaid === false && (
                <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                  <span className="text-lg font-semibold text-gray-800">Total Amount Payable</span>
                  <span className="text-xl font-bold text-gray-800">
                    ${payableTotal}
                  </span>
                </div>
              )}

              {/* Total Paid */}
              {isPaid === true && (
                <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                  <span className="text-lg font-semibold text-gray-800">Total Paid</span>
                  <span className="text-xl font-bold text-gray-800">
                    ${payableTotal}
                  </span>
                </div>
              )}

              {/* Balance Due */}
              {isPaid && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Balance Due</span>
                  <span className="font-bold text-green-600">$0.00</span>
                </div>
              )}
            </div>

            {/* Action Button */}
            <div className="pt-6">
              {isPaid ? (
                <div className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold py-4 text-center rounded-2xl">
                  <div className="flex items-center justify-center space-x-2">
                    <FaCheckCircle className="w-5 h-5" />
                    <span>Payment Completed</span>
                  </div>
                </div>
              ) : (
                <div className="w-full">
                  {(loginId?.length > 0 && clientKey?.length > 0) && (
                    <HostedForm 
                      authData={authData} 
                      onSubmit={handleSubmit} 
                      environment="PRODUCTION" 
                      buttonClassName="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-4 text-center rounded-2xl transition-all duration-200 transform hover:scale-105 shadow-lg border-0 cursor-pointer" 
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 flex items-center space-x-2 text-gray-500">
        <span className="text-sm">Powered by</span>
        <img className="h-4" src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} alt="SalesCaptain" />
        <span className="text-sm capitalize">{localStorage.getItem('h_name') ?? 'SalesCaptain'}</span>
      </div>
    </div>
  );
}

export default AuthorizeNet;
